import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React from "react";
import CoordMap from "./CoordMap";
import MarkersMap from "./MarkersMap";
export var Map = function Map(a) {
  var b = a.levels,
      c = _objectWithoutProperties(a, ["levels"]);

  b = b.filter(function (a) {
    return a.image;
  });

  var d = b,
      e = _slicedToArray(d, 1),
      f = e[0],
      g = f.markers && f.markers.length;

  return g ? /*#__PURE__*/React.createElement(MarkersMap, Object.assign({}, c, {
    levels: b
  })) : /*#__PURE__*/React.createElement(CoordMap, Object.assign({}, c, {
    levels: b
  }));
};
export default Map;